var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUdsigtspunkt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "5.5mm",
    height: "5.5mm",
    viewBox: "0 0 15.591 15.591",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 15.591,
    height: 15.591,
    rx: 7.795,
    fill: "#427c7f"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.849,7.886h0l-.031-.071-.735-1.671h0a2.236,2.236,0,0,0-1.714-1.319L10.21,4.54a1.006,1.006,0,0,0-1.83.665l.046.267a2.324,2.324,0,0,0-.232.281.752.752,0,0,0-.1-.056.825.825,0,0,0-.678.079,2.223,2.223,0,0,0-.252-.3l.046-.267a.963.963,0,0,0-.645-1.034A.963.963,0,0,0,5.38,4.54l-.162.284A2.234,2.234,0,0,0,3.5,6.143h0l-.734,1.67-.032.072h0A2.476,2.476,0,0,0,2.5,8.937a2.538,2.538,0,0,0,5.056.33l.008,0,.016-.147.074-.653a.9.9,0,0,0,.293.006l.072.632.018.162.008,0a2.537,2.537,0,0,0,5.055-.33A2.475,2.475,0,0,0,12.849,7.886Zm-7.805,2.6a1.551,1.551,0,1,1,1.55-1.553A1.552,1.552,0,0,1,5.044,10.49Zm5.5,0A1.551,1.551,0,1,1,12.1,8.937,1.553,1.553,0,0,1,10.546,10.49Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUdsigtspunkt);
export default __webpack_public_path__ + "static/media/UDSIGTSPUNKT.b6bd4851b7f10728c73462787f93526e.svg";
export { ForwardRef as ReactComponent };